/* Mosaic Lab — lookbook filtering + pattern modal
   No dependencies. Safe to load on every page; it no-ops if the markup is absent. */
(function () {
  'use strict';

  function initLookbook(root) {
    if (root.dataset.mlReady === '1') return;
    root.dataset.mlReady = '1';

    var state = { material: 'all', area: 'all' };
    var cards = Array.prototype.slice.call(root.querySelectorAll('.ml-card'));
    var buttons = Array.prototype.slice.call(root.querySelectorAll('.ml-fbtn'));
    var countEl = root.querySelector('[data-ml-count]');
    var emptyEl = root.querySelector('[data-ml-empty]');

    function matches(card) {
      var mats = (card.dataset.material || '').split(',');
      var areas = (card.dataset.area || '').split(',');
      return (state.material === 'all' || mats.indexOf(state.material) > -1) &&
             (state.area === 'all' || areas.indexOf(state.area) > -1);
    }

    function render() {
      var shown = 0;
      cards.forEach(function (c) {
        var ok = matches(c);
        c.hidden = !ok;
        if (ok) shown++;
      });
      buttons.forEach(function (b) {
        b.setAttribute('aria-pressed', String(state[b.dataset.key] === b.dataset.value));
      });
      if (emptyEl) emptyEl.hidden = shown > 0;
      if (countEl) {
        var s = shown + (shown === 1 ? ' pattern' : ' patterns');
        if (state.material !== 'all') s += ' in ' + state.material;
        if (state.area !== 'all') s += ' for ' + state.area;
        countEl.textContent = s;
      }
      var url = new URL(window.location.href);
      state.material === 'all' ? url.searchParams.delete('material') : url.searchParams.set('material', state.material);
      state.area === 'all' ? url.searchParams.delete('area') : url.searchParams.set('area', state.area);
      history.replaceState(null, '', url);
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        state[b.dataset.key] = b.dataset.value;
        render();
      });
    });

    // Deep links: /pages/mosaic-lab?material=zellige&area=backsplash
    var qs = new URLSearchParams(window.location.search);
    if (qs.get('material')) state.material = qs.get('material');
    if (qs.get('area')) state.area = qs.get('area');
    render();

    // Modal
    var modal = root.querySelector('[data-ml-modal]');
    if (!modal) return;
    // Fill a detail row, hiding its label too when there is nothing to show
    function setRow(selector, value) {
      var dd = modal.querySelector(selector);
      if (!dd) return;
      var dt = dd.previousElementSibling;
      if (value) {
        dd.textContent = value;
        dd.style.display = '';
        if (dt) dt.style.display = '';
      } else {
        dd.textContent = '';
        dd.style.display = 'none';
        if (dt) dt.style.display = 'none';
      }
    }

    // The text written into the enquiry form
    function summarise(card) {
      var bits = [card.dataset.name || 'Pattern'];
      if (card.dataset.materialLabel) bits.push(card.dataset.materialLabel);
      if (card.dataset.format) bits.push(card.dataset.format);
      if (card.dataset.finish) bits.push(card.dataset.finish);
      return bits.join(' | ');
    }

    // Close the modal, take the customer to the form, fill in the pattern
    function goToEnquiry(summary, anchor) {
      close();
      var field = document.querySelector('[data-ml-pattern-field]');
      if (field) field.value = summary;
      var target = null;
      if (anchor && anchor.charAt(0) === '#' && anchor.length > 1) {
        target = document.getElementById(anchor.slice(1));
      }
      if (!target) target = document.getElementById('mosaic-lab-contact');
      if (!target && field) target = field.closest('form') || field;
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (field) {
          window.setTimeout(function () { field.focus({ preventScroll: true }); }, 600);
        }
      }
    }

    function open(card) {
      modal.querySelector('[data-ml-modal-img]').innerHTML = card.dataset.full
        ? '<img src="' + card.dataset.full + '" alt="' + (card.dataset.name || '') + '">'
        : card.querySelector('.ml-card__img').innerHTML;
      modal.querySelector('[data-ml-modal-name]').textContent = card.dataset.name || '';
      modal.querySelector('[data-ml-modal-desc]').textContent = card.dataset.desc || '';
      setRow('[data-ml-modal-material]', card.dataset.materialLabel);
      setRow('[data-ml-modal-area]', card.dataset.areaLabel);
      setRow('[data-ml-modal-format]', card.dataset.format);
      setRow('[data-ml-modal-finish]', card.dataset.finish);

      var cta = modal.querySelector('[data-ml-modal-cta]');
      if (cta) {
        var summary = summarise(card);
        var url = (card.dataset.ctaUrl || '').trim();
        var onThisPage = !url || url.charAt(0) === '#';
        if (onThisPage) {
          // Form lives on this page: close the modal and scroll down to it
          cta.href = url || '#mosaic-lab-contact';
          cta.onclick = function (e) {
            e.preventDefault();
            goToEnquiry(summary, url);
          };
        } else {
          // A separate enquiry page: carry the pattern across in the URL
          cta.href = url + (url.indexOf('?') > -1 ? '&' : '?') +
                     'pattern=' + encodeURIComponent(summary);
          cta.onclick = null;
        }
      }
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    cards.forEach(function (c) { c.addEventListener('click', function () { open(c); }); });
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.hasAttribute('data-ml-close')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function boot() {
    document.querySelectorAll('[data-ml-lookbook]').forEach(initLookbook);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();

  // Theme editor support
  document.addEventListener('shopify:section:load', boot);
})();
